import { useSelector } from 'react-redux';


const useSponsored = () => {
  const sponsored = useSelector(state => state.sponsored) || null;
  return { hit: sponsored };
};

export default useSponsored;
